import type { Structure } from '@wix/thunderbolt-becky-types'
import { isDisplayedOnly, isRepeater, MODES_TYPE } from '@wix/thunderbolt-commons'
import type { IPropsStore, IComponentStructureFixer } from '@wix/thunderbolt-symbols'
import { inflateRepeater, inflateRepeaterItem, isComponentRepeaterDescendant } from './repeaterUtils'
import { inflateHoverBoxWithModes, inflateSospWithModes, isModesFeatureActive, getActiveMode } from './modesUtils'
import type { DisplayedIdToRepeatedAncestorId, RepeatersData, SospActivation } from '../types'
import { SOSP_MODE_TYPE } from '../constants'

export const toInflatedStructure = (
	id: string,
	structure: Structure,
	repeatersData: RepeatersData,
	props: IPropsStore,
	isSospActiveOnCurrentPage: SospActivation,
	ComponentStructureFixer: IComponentStructureFixer,
	displayedOnlyToRepeaterAncestor: DisplayedIdToRepeatedAncestorId
) => {
	const comp = structure[id]
	if (isDisplayedOnly(id)) {
		if (isComponentRepeaterDescendant(id, structure, props, repeatersData, displayedOnlyToRepeaterAncestor)) {
			// TODO PLAT-2124: Check if we can avoid inflating based on carmi structure
			return inflateRepeaterItem(id, structure, props, repeatersData)
		}
		return comp
	}
	if (comp) {
		if (isRepeater(comp.componentType)) {
			return inflateRepeater(comp, props, repeatersData)
		}
		if (isModesFeatureActive(comp)) {
			const activeMode = getActiveMode(comp.id, structure, props)
			if (activeMode) {
				switch (activeMode.type) {
					case SOSP_MODE_TYPE:
						return inflateSospWithModes(comp, isSospActiveOnCurrentPage)
					case MODES_TYPE.hover:
					case MODES_TYPE.default:
						return inflateHoverBoxWithModes(comp, structure, activeMode.modeId)
					default:
						return comp
				}
			}
			return comp
		}
	}
	return comp
}
